import React from "react";
import { Navigate } from "react-router";
import { useSelector } from "react-redux";
import { isAuthenticated, isAuthenticating, authenticatedUser } from "../../redux/slice";
import LoadingScreen from "../../../../shared/components/Loading";

const routeForRole = (role: string) => {
    switch (role) {
        case "assistant":
            return "/data-entering";
        case "manager":
            return "/management/units";
        case "supervisor":
        case "admin":
            return "/supervising/queued";
        default:
            return "/login";
    }
};

const IndexRedirect = () => {
    const authenticated = useSelector(isAuthenticated);
    const authenticating = useSelector(isAuthenticating);
    const currentUser = useSelector(authenticatedUser);

    if (authenticating) return <LoadingScreen />;

    if (!authenticated) return <Navigate to="/login" replace />;

    if (!currentUser) return <LoadingScreen />;

    return <Navigate to={routeForRole(currentUser.role)} replace />;
};

export default IndexRedirect;
